import axios from "axios"
import { appInfo } from "../AppInfo"

export const localizedReourceApi = {
    loadAll: (lan:string) => {
        return axios.get(`${appInfo.baseApiURL}/localized-resource/${lan}`)
    }
}